import { mapState } from "vuex";

export default {
  methods: {
    isProcoreEnabled(clientId = undefined) {
      if (clientId) {
        const client = (this.clients || []).find((c) => c.clientId === clientId);
        if (client) return client.procoreEnabled;
      }
      return this.userProfile.Client.procoreEnabled;
    },
  },
  computed: {
    ...mapState(["userProfile", "clients"]),
  },
};
